// BASE, CLEAN STATE

const { getYearRange } = require('../../util/util');

const cleanState = {
  stickyFilter: false,
  marketViewPosition: null,
  viewCheck: true,
  filterObject: {
    portfolio: { name: 'All Portfolios', uuid: '' },
    timePeriod: {
      name: 'This Year',
      ...getYearRange(),
    },
    viewBy: 'manufacturer',
    allPortfolioFilters: [],
  },
};

const initialState = {
  ...cleanState,
};

export default (state = initialState, { type, value }) => {
  switch (type) {
    case 'SET_STICKY_FILTER':
      return {
        ...state,
        stickyFilter: value,
      };
    case 'SET_MARKET_VIEW_POSITION':
      return {
        ...state,
        marketViewPosition: value,
      };
    case 'SET_PORTFOLIO_FILTERS':
      return {
        ...state,
        allPortfolioFilters: value,
      };
    case 'SET_FILTER_OBJECT':
      return {
        ...state,
        filterObject: value,
      };
    case 'SET_VIEW_CHECK':
      return {
        ...state,
        viewCheck: value,
      };
    default:
      return state;
  }
};
